import {
    TRACK_ORDER,
    TRACK_ORDER_SUCCESS,
    TRACK_ORDER_FAILURE,
    REACH_PLAN,
    REACH_PLAN_SUCCESS,
    REACH_PLAN_FAILURE,
    REFERAL,
    REFERAL_SUCCESS,
    REFERAL_FAILURE,
    REFERAL_GET,
    REFERAL_GET_SUCCESS,
    REFERAL_GET_FAILURE,
    TRACK_ORDER_GET,
    TRACK_ORDER_GET_SUCCESS,
    TRACK_ORDER_GET_FAILURE,
} from './actionTypes';
import * as types from './types';

//track order api
export const trackOrder = (payload: types.TrackOrderRequestPayload): types.TrackOrderRequest => ({
    type: TRACK_ORDER,
    payload,
});

export const trackOrderSuccess = (payload: types.TrackOrderSuccessPayload): types.TrackOrderSuccess => ({
    type: TRACK_ORDER_SUCCESS,
    payload,
});

export const trackOrderFailure = (payload: types.TrackOrderFailurePayload): types.TrackOrderFailure => ({
    type: TRACK_ORDER_FAILURE,
    payload,
});


//track order get api call by customer id
export const trackOrderGet = (payload: types.TrackOrderGetRequestPayload): types.TrackOrderGetRequest => ({
    type: TRACK_ORDER_GET,
    payload,
});

export const trackOrderGetSuccess = (payload: types.TrackOrderGetSuccessPayload): types.TrackOrderGetSuccess => ({
    type: TRACK_ORDER_GET_SUCCESS,
    payload,
});

export const trackOrderGetFailure = (payload: types.TrackOrderGetFaliurePayload): types.TrackOrderGetFailure => ({
    type: TRACK_ORDER_GET_FAILURE,
    payload,
});

// reach plan api
export const reachPlan = (payload: types.ReachPlanRequestPayload): types.ReachPlanRequest => ({
    type: REACH_PLAN,
    payload,
});

export const reachPlanSuccess = (payload: types.ReachPlanSuccessPayload): types.ReachPlanSuccess => ({
    type: REACH_PLAN_SUCCESS,
    payload,
});

export const reachPlanFailure = (payload: types.ReachPlanFailurePayload): types.ReachPlanFailure => ({
    type: REACH_PLAN_FAILURE,
    payload,
});

// referal api
export const referal = (payload: types.ReferalRequestPayload): types.ReferalRequest => ({
    type: REFERAL,
    payload,
});

export const referalSuccess = (payload: types.ReferalSuccessPayload): types.ReferalSuccess => ({
    type: REFERAL_SUCCESS,
    payload,
});

export const referalFailure = (payload: types.ReferalFailurePayload): types.ReferalFailure => ({
    type: REFERAL_FAILURE,
    payload,
});

// referal get by email id
export const referalGet = (payload: types.ReferalGetRequestPayload): types.ReferalGetRequest => ({
    type: REFERAL_GET,
    payload,
});

export const referalGetSuccess = (payload: types.ReferalGetSuccessPayload): types.ReferalGetSuccess => ({
    type: REFERAL_GET_SUCCESS,
    payload,
});

export const referalGetFailure = (payload: types.ReferalGetFailurePayload): types.ReferalGetFailure => ({
    type: REFERAL_GET_FAILURE,
    payload,
});
